
import { Voni } from '../client';

export interface User {
  id: number;
  email: string;
  full_name?: string;
  is_active: boolean;
  is_superuser: boolean;
  plan_key: string;
  preferences?: Record<string, unknown>;
}

export class UserResource {
  constructor(private client: Voni) {}

  async me(): Promise<User> {
    return this.client.request<User>('GET', '/users/me');
  }
}
